module.exports = __webpack_public_path__ + "static/r5-9cf1b8b3f5a78be212683d0b69708e7f.jpg";